<template>
  <header class="header mt-auto py-3 bg-light">
    <div class="container">
      <span> 
      <img src="../assets/newprosw.png" width="120" height="30"/>
      </span>
      <span class="spaceleft"> Dashboard </span>
      <img style="position:absolute;right:30px"
        src="../assets/newprosw.png" width="120" height="30"/>
    </div>
  </header>

  <div v-if="forcechgpwd == 0" class="bd-login ps-lg-4">
    <div class="container">
      <div style='font-size:14pt;font-weight:bold;padding-bottom:10px'>Login:</div>
          <div class="form-floating mb-3">
              <input required type="text" class="form-control" id="floatingInput" 
               placeholder="input userid" v-model="userid">
              <label for="floatingInput">User ID</label>
          </div>

          <div class="form-floating">
             <input  @keyup.enter=dologin() type="password" 
              required class="form-control" id="floatingPassword" 
             placeholder="Password" v-model="password">
             <label for="floatingPassword">Password</label>
          </div>
      </div>

      <div style='margin:auto;width:400px'>
        <br><br>
        <div v-if="errormsg !=''" class="border mb-3" 
            style='color:red;background:yellow'>
            {{errormsg}}
         </div>
        <div style='margin:auto;width:10rem'>
           <button class="btn btn-primary btn-block mb-4" 
                  @click=dologin>Login</button>
      </div>
    </div>
  </div>

  <div v-if="forcechgpwd >= 1" class="bd-login ps-lg-4">
    <div class="container">
      <div style='font-size:14pt;font-weight:bold;padding-bottom:10px'>
         <span v-if="forcechgpwd == 1"> Your Password has Expired</span>
         <span v-if="forcechgpwd == 2"> Change Password (First Time Login)</span>
      </div>
          <div class="form-floating mb-3">
             <input type="password" 
              required class="form-control" id="floatingPassword3" 
             placeholder="confirm" v-model="n_password">
             <label for="floatingPassword3">New Password</label>
          </div>

          <div class="form-floating">
             <input type="password" 
              required class="form-control" id="floatingPassword2" 
             placeholder="confirm" v-model="r_password">
             <label for="floatingPassword2">Confirm Password</label>
          </div>
      </div>

      <div style='margin:auto;width:400px'>
        <br><br>
        <div v-if="errormsg !=''" class="border mb-3" 
            style='color:red;background:yellow'>
            {{errormsg}}
         </div>
        <div style='margin:auto;width:10rem'>
           <button class="btn btn-primary btn-block mb-4" 
                  @click=changepwd>Change</button>
      </div>
    </div>
  </div>

  <footer class="footer mt-auto py-3 bg-light">
    <div class="container">
      <span class="text-muted">&copy;Copy Right PT. METALOGIC INFOMITRA</span>
      <img style="position:absolute;right:30px"
        src="../assets/newprosw.png" width="120" height="30"/>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'DashLogin',
  props: {
    msg: String
  },
  computed: {
    userlogin() {
      return this.$store.getters.userlogin ;
    },
    curpage() {
      return this.$store.getters.curpage ;
    },
    forcechgpwd() {
      return this.$store.getters.forcechgpwd;
    }
  },
  watch : {
    forcechgpwd: function (newval) {
      this.errormsg = "" ;
      this.r_password = "" ;
      this.n_password = "" ;
      if (newval == 0) this.password = "" ;
    }
  },
  data() {
    return { 
      numoferr : 0,
      errormsg : '',
      userid : '',
      password : '',
      r_password : '',
      n_password : ''
    }
  },
  methods : {
    checkpassword(password) {
      let regex =
/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
        return regex.test(password) ;
    },
    changepwd() {
        this.config = this.$store.getters.usermgmt ;
        this.userroles = this.config.userroles ;

        if ( this.n_password.length < this.config.passwordlen) {
             return alert ('PASSWORD LENGTH MIN ' + 
                  this.config.passwordlen + ' CHARS') ;
        }
        if (this.r_password != this.n_password)
            return alert ("NEW PASSWD and CONFIRMATION not match") ;

        if (this.config.passwordstrength) 
             if (! this.checkpassword(this.n_password)) {
                  return alert ("Password must contain mix letter, number and special") ;
             }

        this.$store.commit("changepwd", 
            { "user" : this.userid,
              "oldpasswd" :  this.password,
              "newpasswd" :  this.n_password
            }) ;
        if (this.forcechgpwd == 0) this.password = '' ;
        this.n_password = '';
        this.r_password = '';
    },
    dologin() {
       this.errormsg = "Please Wait Request for Login ...." ;
       this.$store.commit("login", 
       { "user" : this.userid, "password" :  this.password, "comp" : this } )  ;
    },
    writemsg(err) {
      this.errormsg = err ;
      if (this.numoferr > 0) 
         this.errormsg = this.numoferr + ":: " + err ;
      else
         this.errormsg = err ;
      this.numoferr ++ ;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-login {
    padding: 6rem;
    margin:  auto;
    border-width: 1px;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    width : 30rem ;
}
footer {
   position: absolute ;
   bottom : 1rem ;
}
.spaceleft {
  left : 1rem ;
  position : relative;
  color: grey ;
  font-size : 14pt ;

}
header {
   position: absolute ;
   top : 0.5rem ;
   height : 3rem ;
}
</style>
